import React from "react";
import { Grid, Link } from "@mui/material";
import PrivacyIcon from './privacyicon.png';
import AdChoices from './adchoices.png';
import './styles.css';

const FooterPage = () => {
  return (

<Grid container className="footer-container">
        <Grid item xs={12}>&copy; 2025 GENERAL MOTORS</Grid>
        
        <Grid container alignItems="center">
        <Grid item>
            <Link className="link" href="https://www.gm.com/sitemap">
              Sitemap
            </Link>
          </Grid>
          <Grid item>&ensp; | &ensp;</Grid>
          <Grid item>
            <Link className="link" href="https://www.gm.com/copyright-trademark?evar25=ultium_footer">
              Copyright/Trademark
            </Link>
          </Grid>
          <Grid item>&ensp; | &ensp;</Grid>
          <Grid item>
            <Link className="link" href="https://www.gm.com/privacy-statement?evar25=ultium_footer">
              GM Privacy Statement
            </Link>
          </Grid>
        </Grid>
        
        <Grid container alignItems="center" gap="13px">
          <div>
            <img src={AdChoices} alt="Ad Choices" style={{ width: '16px' }} />
          </div>
          <Grid item>
            <Link className="link" href="https://experience.gm.com/ad-choices?evar25=ultium_footer">
              Ad Choices
            </Link>
          </Grid>
        </Grid>
        
        <Grid container alignItems="center" gap="10px" >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img src={PrivacyIcon} alt="Privacy Icon" style={{ width: '20px', filter: 'invert(100%) grayscale(100%)' }} />
          <Link className="link" href="https://www.gm.com/consumer-privacy?evar25=ultium_footer">
            Your Privacy Choices & Opt-Out Rights
          </Link>
        </div>

        </Grid>
      </Grid>
  );
};

export default React.memo(FooterPage);